import { PercentFormatter, StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * DollarAndPercentageTooltip: this tooltip includes both the dollar value and the percentage change of the data point.
 */
export class DollarAndPercentageTooltip {
	public static getFormatter(): any {
		const baseMetricValue: number = 10000;
		return function (): string {
			let out = '';
			let setTooltipHeader = true;
			this.points.forEach(point => {
				if (setTooltipHeader) {
					out += '<h4 class="performance-tooltip-header">' + Highcharts.dateFormat('%a, %b %e, %Y', this.x) + '</h4>';
					setTooltipHeader = false;
				}

				const seriesColor = point.series.color;
				const valueAsPercentChanged = new PercentFormatter(2).format((point.y - baseMetricValue) / baseMetricValue, true);
				out += '<div class="performance-tooltip" style="color: ' + StringUtil.escapeHtml(seriesColor) + ';">' + '<table>';
				out +=
					'<tr>' +
					// name cell
					'<td style="color:' +
					StringUtil.escapeHtml(seriesColor) +
					';">' +
					StringUtil.escapeHtmlWithChartLineBreaks(StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)) +
					'</td>' +
					'</tr>' +
					'<tr>' +
					// $ val cell
					'<td class="dollar-value" style="background-color:' +
					StringUtil.escapeHtml(seriesColor) +
					';">' +
					'$' +
					Highcharts.numberFormat(point.y, 2, '.', ',') +
					'</td>' +
					// % change
					'<td class="percent-value" style="color:' +
					StringUtil.escapeHtml(seriesColor) +
					';">' +
					StringUtil.escapeHtml(valueAsPercentChanged) +
					'</td>' +
					'</tr>';
				out += '</table></div>';
			});
			return out;
		};
	}
}
